import { render, staticRenderFns } from "./coin.vue?vue&type=template&id=76b62dd0&scoped=true"
import script from "./coin.vue?vue&type=script&lang=js"
export * from "./coin.vue?vue&type=script&lang=js"
import style0 from "./coin.vue?vue&type=style&index=0&id=76b62dd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b62dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b62dd0')) {
      api.createRecord('76b62dd0', component.options)
    } else {
      api.reload('76b62dd0', component.options)
    }
    module.hot.accept("./coin.vue?vue&type=template&id=76b62dd0&scoped=true", function () {
      api.rerender('76b62dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/coin.vue"
export default component.exports